var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"extra-data-for-company"}},[_c('memlist-text-input',{attrs:{"title":_vm.extra_data.name,"type":"text"},on:{"input":_vm.change_data},model:{value:(_vm.local_item.value),callback:function ($$v) {_vm.$set(_vm.local_item, "value", $$v)},expression:"local_item.value"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }